import { displayFunctions } from '../../../utils/chartsUtils';

export const data = {
  plots: {
    impressions: {
      likes: {
        trend: 1,
        values: [100, 120, 130, 140, 150, 160, 170],
        displayValue: displayFunctions.sum([100, 120, 130, 140, 150, 160, 170])
      }
    },
    likes: {
      likes: {
        trend: 1,
        values: [50, 60, 45, 70, 80, 75, 90],
        displayValue: displayFunctions.sum([50, 60, 45, 70, 80, 75, 90])
      }
    },
    reach: {
      reach: {
        trend: 0,
        values: [80, 100, 120, 90, 110, 100, 120],
        displayValue: displayFunctions.sum([80, 100, 120, 90, 110, 100, 120])
      }
    },
    total_interactions: {
      reach: {
        trend: 1,
        values: [100, 110, 120, 130, 140, 150, 160],
        displayValue: displayFunctions.sum([100, 110, 120, 130, 140, 150, 160])
      }
    },
    profile_followers: {
      reach: {
        trend: 1,
        values: [150, 200, 220, 240, 270, 290, 320],
        displayValue: 320
      }
    },
    profile_analytics: {
      profile_views: {
        trend: 1,
        values: [100, 110, 120, 130, 140, 150, 160],
        displayValue: displayFunctions.sum([100, 110, 120, 130, 140, 150, 160])
      },
      website_clicks: {
        trend: 1,
        values: [50, 60, 45, 70, 80, 75, 90],
        displayValue: displayFunctions.sum([50, 60, 45, 70, 80, 75, 90])
      },
      profile_links_taps: {
        trend: 1,
        values: [40, 50, 60, 70, 80, 90, 100],
        displayValue: displayFunctions.sum([40, 50, 60, 70, 80, 90, 100])
      }
    }
  },
  additionalData: {
    posts_per_day: {
      trend: -1,
      values: [0, 0, 1, 0, 0, 2, 1],
      displayValue: 3
    }
  },
  dates: getLastSevenDays()
};

function getLastSevenDays(): any {
  const dates = [];
  for (let i = 1; i < 8; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(date.toISOString().split('T')[0] + 'T00:00:00+00:00');
  }
  return dates.reverse();
}
